import { isDevInspectorEnabled } from './devInspectorFlag'

export type DevSessionLogEntry = {
  ts: string
  source: string
  type: string
  summary: string
  payload?: unknown
}

const MAX_ENTRIES = 100

let entries: DevSessionLogEntry[] = []
const listeners = new Set<() => void>()

function notify(): void {
  listeners.forEach((cb) => cb())
}

export const devSessionLog = {
  push(entry: Omit<DevSessionLogEntry, 'ts'> & { ts?: string }): void {
    if (!isDevInspectorEnabled()) {
      return
    }
    entries = [
      ...entries,
      {
        ...entry,
        ts: entry.ts ?? new Date().toISOString(),
      },
    ].slice(-MAX_ENTRIES)
    notify()
  },

  getEntries(): DevSessionLogEntry[] {
    return [...entries].reverse()
  },

  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },

  clear(): void {
    entries = []
    notify()
  },
}

export function logReducerAction(source: string, action: { type: string; payload?: unknown }): void {
  devSessionLog.push({
    source,
    type: action.type,
    summary: action.type,
    payload: action.payload,
  })
}
